import { createClient } from '@supabase/supabase-js'

/**
 * Учётные записи целиком на стороне Supabase Auth: регистрация, вход,
 * подтверждение почты, восстановление пароля. Своих паролей мы не храним и не
 * проверяем — наш сервер видит только выданный токен.
 *
 * Публичный ключ в браузере — так и задумано: он открывает ровно авторизацию,
 * а все данные идут через наш API, где живёт служебный ключ.
 */
const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anonKey) {
  // Молчаливый отказ здесь означал бы белый экран без объяснений.
  console.error(
    'Не заданы VITE_SUPABASE_URL и VITE_SUPABASE_ANON_KEY — вход работать не будет.',
  )
}

export const supabase = createClient(url ?? '', anonKey ?? '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})

export async function accessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession()
  return data.session?.access_token ?? null
}

/** Человеческий текст вместо английских сообщений Supabase. */
export function authErrorText(message: string): string {
  const m = message.toLowerCase()
  if (m.includes('invalid login')) return 'Неверная почта или пароль.'
  if (m.includes('email not confirmed')) return 'Подтверди почту — письмо уже отправлено.'
  if (m.includes('already registered')) return 'Такая почта уже зарегистрирована.'
  if (m.includes('password') && m.includes('6')) return 'Пароль короче шести знаков.'
  if (m.includes('rate limit')) return 'Слишком часто. Подожди минуту и попробуй снова.'
  return 'Не получилось. Попробуй ещё раз.'
}
